import React, { ReactNode } from 'react';
import { useUiFromSpecContext } from '../UiFromSpec';

interface Props {
  children: ReactNode;
}

const FormStyle = ({ children }: Props) => {

  const {designState} = useUiFromSpecContext();
  const baseFormStyle = {
    backgroundColor: designState.backgroundColor,
    color: designState.textColor
  };

  return (
    <div style={baseFormStyle}>
      {children}
    </div>
  );
};

export default FormStyle;